import { useQuery } from '@tanstack/react-query';
import { getWidgetListByClient } from '../services/DashboardService.js';
import { useNavigationCtx } from '@/components/NavigationProvider.jsx';

export const useWidgets = () => {
  const navigationCtx = useNavigationCtx();
  const id = navigationCtx?.state.selectedOption?.project_nexus_id;
  return useQuery({
    enabled: Boolean(id),
    gcTime: 1000 * 60 * 60,
    queryFn: () => getWidgetListByClient(id!),
    queryKey: ['getWidgetList', id],
    staleTime: 1000 * 60 * 5,
  });
};
